import { OptionalNullableDisplayNameSchema } from '../../valibot/schema/DisplayName.type'
import { InferOutput, object, nullable } from 'valibot'
import { PlayerColorSchema } from '../player/PlayerColor.type'
import { ArmyPaintIdSchema } from './ArmyPaintId.type'
import { StateMapDiskSchema } from '../state/state_map_disk.enum'
import { ProfileIdSchema } from '../ProfileId.type'

export const ArmyPaintSchema = object({
  id: ArmyPaintIdSchema,
  user_id: nullable(ProfileIdSchema),
  disk: StateMapDiskSchema,
  dname: OptionalNullableDisplayNameSchema,
  color1: PlayerColorSchema,
  color2: PlayerColorSchema,
})

export type ArmyPaint = InferOutput<typeof ArmyPaintSchema>
